import { render } from "./ShopEdit.vue?vue&type=template&id=6e459040&scoped=true"
import script from "./ShopEdit.vue?vue&type=script&lang=ts"
export * from "./ShopEdit.vue?vue&type=script&lang=ts"

import "./ShopEdit.vue?vue&type=style&index=0&id=6e459040&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e459040"

export default script